webpackJsonp([92],{

/***/ 2378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opensalud4allContactForm_vue__ = __webpack_require__(2856);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe4aaa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opensalud4allContactForm_vue__ = __webpack_require__(3064);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3062)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fe4aaa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opensalud4allContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe4aaa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opensalud4allContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/forms/Opensalud4allContactForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fe4aaa4", Component.options)
  } else {
    hotAPI.reload("data-v-0fe4aaa4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OPENLEGAL_PROMOTION_NEWSLETTER_TYPE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;var OPENLEGAL_PROMOTION_NEWSLETTER_TYPE='OPENLEGAL_PROMOTION';/* harmony default export */ __webpack_exports__["a"] = ({sendCompaniesContactForm:function sendCompaniesContactForm(form){return client.post('/mk/companies-contact-form',form);},subscribePromotionOpenlegal:function subscribePromotionOpenlegal(email){return client.post('/mk/newsletter-registrations',{email:email,type:OPENLEGAL_PROMOTION_NEWSLETTER_TYPE});}});

/***/ }),

/***/ 2856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_MarketingRepository__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_GeographyRepository__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseAlert__ = __webpack_require__(517);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Opensalud4allContactForm',
  components: {
    BaseAlert: __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseAlert__["a" /* default */]
  },
  i18n: {
    messages: {
      es: __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default.a,
      en: __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json___default.a,
      mx: __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default.a,
      pt: __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json___default.a
    }
  },
  methods: {
    showIfAnother: function showIfAnother() {
      var ong = document.querySelector('.ong-name');
      if (this.form.formSelectUser.selected === '3') {
        ong.classList.remove('hide');
      }
    },
    sendContactForm: function sendContactForm() {
      var _this = this;

      if (this.form.formSelectUser.selected === '3') {
        this.form.typeEntityName = 'Otros';
      } else if (this.form.formSelectUser.selected === '2') {
        this.form.typeEntityName = 'ONG';
      } else if (this.form.formSelectUser.selected === '1') {
        this.form.typeEntityName = 'Profesional de la Salud';
      }
      if (this.form.firstName === null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.error-firstname'));
        return;
      }
      if (this.form.lastName === null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors-lastname'));
        return;
      }
      if (this.form.email === null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors-email'));
        return;
      }
      if (this.form.country === null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors-country'));
        return;
      }
      if (this.form.formSelectUser.selected === null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-entity-ong-type'));
        return;
      }
      if (!this.formLegalConsentOptions.privacyPolicy) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-consent'));
        return;
      }
      if (!this.formLegalConsentOptions.privacyPolicy) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-consent'));
      }

      this.form.trafficSource = this.$route.query.utm_source || 'organic';

      this.form.productName = 'opensalud4all';
      __WEBPACK_IMPORTED_MODULE_3__repositories_MarketingRepository__["a" /* default */].sendCompaniesContactForm(this.form).then(function (response) {
        /* this.$store.dispatch('showAlert', { text: this.$t('companies-contact-form.form.success'), variant: 'success' }) */
        _this.$router.push(_this.callbackPath);
      });
    }
  },
  props: {
    black: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('companies-contact-form.contact-us');
      }
    },
    platform: {
      type: String,
      required: false,
      default: 'Opensalud'
    },
    productName: {
      type: String,
      required: false,
      default: '360'
    },
    subtitle: {
      type: String,
      required: false
    },
    serviceType: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('companies-contact-form.service-type.digital-health');
      }
    },
    forIndividuals: {
      type: Boolean,
      required: false,
      default: false
    },
    forIndividualsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    forCompaniesOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    showDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEmployeesNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    showReason: {
      type: Boolean,
      required: false,
      default: false
    },
    showCollegiateNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    hideWebsite: {
      type: Boolean,
      required: false,
      default: false
    },
    callbackPath: {
      type: String,
      required: false,
      default: '/contact/success'
    }
  },
  data: function data() {
    return {
      form: {
        firstName: null,
        formSelectUser: {
          options: [{ value: '1', text: this.$t('user.prof') }, { value: '2', text: this.$t('user.ong') }, { value: '3', text: this.$t('user.another') }],
          selected: null
        },
        lastName: null,
        country: null,
        anotherEntity: null,
        typeEntityName: null,
        // languages: null,
        /*  state: null, */
        email: null
        // speciality: null
      },
      formLegalConsentOptions: {
        privacyPolicy: false,
        subscriptionTypeId: '8323529'
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var ong = document.querySelector('.ong-name');
    ong.classList.add('hide');
    __WEBPACK_IMPORTED_MODULE_4__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(28).then(function (response) {
      _this2.formOptions.provinces = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(response.data.sort(function (a, b) {
        return _this2.$i18nHelpers.normalize(a.name).localeCompare(_this2.$i18nHelpers.normalize(b.name));
      }), function (item) {
        var stateName = _this2.$i18nHelpers.normalize(item.name);
        return {
          value: stateName,
          label: stateName
        };
      });
    });
    if (this.forCompaniesOnly && !this.form.entityType) {
      this.form.entityType = 'company';
    } else if (this.forIndividualsOnly && !this.form.entityType) {
      this.form.entityType = 'individual';
    }
  },

  computed: {
    isCompany: function isCompany() {
      return (!this.forIndividuals || this.form.entityType === 'company') && !this.forIndividualsOnly || this.forCompaniesOnly;
    }
  }
});

/***/ }),

/***/ 3062:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("65a1735a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0fe4aaa4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Opensalud4allContactForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0fe4aaa4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Opensalud4allContactForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3063:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0fe4aaa4]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0fe4aaa4],.slide-down-leave-active[data-v-0fe4aaa4]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0fe4aaa4],.slide-down-leave-to[data-v-0fe4aaa4]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0fe4aaa4],.slide-fade-left-leave-active[data-v-0fe4aaa4]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0fe4aaa4],.slide-fade-left-leave-to[data-v-0fe4aaa4]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0fe4aaa4]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0fe4aaa4],.fade-leave-to[data-v-0fe4aaa4]{opacity:0\n}\n.hide[data-v-0fe4aaa4]{display:none\n}\n.mobile[data-v-0fe4aaa4]{padding-bottom:0rem !important\n}\n.mobile-subtitle[data-v-0fe4aaa4]{padding-top:0rem !important;padding-bottom:0rem !important\n}\n.mobile-form[data-v-0fe4aaa4]{padding-top:0rem !important;padding-bottom:0rem !important\n}\n.mobile-maxheight[data-v-0fe4aaa4]{min-height:77vh !important\n}\n.section[data-v-0fe4aaa4]{text-align:left\n}\n.section[data-v-0fe4aaa4]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-0fe4aaa4]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section .content[data-v-0fe4aaa4]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .content[data-v-0fe4aaa4]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section h3[data-v-0fe4aaa4]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section h3[data-v-0fe4aaa4]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h3[data-v-0fe4aaa4]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section h3[data-v-0fe4aaa4]{font-size:1.5rem\n}\n}\n.section h5[data-v-0fe4aaa4]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section h5[data-v-0fe4aaa4]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h5[data-v-0fe4aaa4]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section h5[data-v-0fe4aaa4]{padding:0rem\n}\n}\n.section .subtitle[data-v-0fe4aaa4]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section .subtitle[data-v-0fe4aaa4]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section .subtitle[data-v-0fe4aaa4]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .subtitle[data-v-0fe4aaa4]{margin-top:1rem\n}\n}\n.section .subtitle p[data-v-0fe4aaa4]{font-size:1.25rem\n}\n.section .col-bg[data-v-0fe4aaa4]{height:100%;min-height:60dvh;background-size:cover\n}\n.section .quote[data-v-0fe4aaa4]{text-transform:uppercase;font-size:.8rem\n}\n.section .quote p[data-v-0fe4aaa4]{letter-spacing:.75px\n}\n.section .quote span[data-v-0fe4aaa4]{font-weight:bold;color:#8A8A8A\n}\n@media only screen and (min-width: 1024px){\n.section[data-v-0fe4aaa4]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section[data-v-0fe4aaa4]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section[data-v-0fe4aaa4]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-0fe4aaa4]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section[data-v-0fe4aaa4]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section[data-v-0fe4aaa4]{padding-right:2rem;padding-left:2rem\n}\n}\n.bg-black[data-v-0fe4aaa4]{background-color:#1D1D1E;color:#eee\n}\n.no-full-height[data-v-0fe4aaa4]{min-height:initial !important\n}\n.os-bg-white[data-v-0fe4aaa4]{background-color:#E4E4E4 !important\n}\n", ""]);

// exports


/***/ }),

/***/ 3064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "mx-auto",
      class: {
        "section-invert": _vm.black,
        section: !_vm.black,
        "py-10": !_vm.black,
        "mobile-maxheight": _vm.$uiHelpers.isMobile
      },
      attrs: { id: "contact-form" }
    },
    [
      _c(
        "b-col",
        {
          class: {
            "bg-black": _vm.black,
            "content my-lg-auto mt-sm-auto pr-lg-5": true,
            mobile: _vm.$uiHelpers.isMobile
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("h3", [_vm._v(" " + _vm._s(_vm.title))]),
          _vm._v(" "),
          _c("p", { class: { "mobile-subtitle": _vm.$uiHelpers.isMobile } }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.subtitle ||
                    _vm.$t("companies-contact-form.subtitle2", {
                      serviceType: _vm.serviceType
                    })
                ) +
                "\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "content pl-lg-5",
          class: {
            "mobile-form": _vm.$uiHelpers.isMobile,
            "os-bg-white": _vm.black,
            "my-auto": !_vm.black
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("div", { class: { "py-sm-10 pl-sm-5": _vm.black } }, [
            _c(
              "div",
              [
                _c("base-select", {
                  staticClass: "mb-4",
                  attrs: {
                    id: "user",
                    label: "text",
                    placeholder: _vm.$t(
                      "companies-contact-form.form.selectUser"
                    ),
                    options: this.form.formSelectUser.options
                  },
                  on: { change: _vm.showIfAnother },
                  model: {
                    value: _vm.form.formSelectUser.selected,
                    callback: function($$v) {
                      _vm.$set(_vm.form.formSelectUser, "selected", $$v)
                    },
                    expression: "form.formSelectUser.selected"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  staticClass: "ong-name",
                  attrs: { placeholder: _vm.$t("formHelp.ongName") },
                  model: {
                    value: _vm.form.anotherEntity,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "anotherEntity", $$v)
                    },
                    expression: "form.anotherEntity"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "pr-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "companies-contact-form.form.name"
                            )
                          },
                          model: {
                            value: _vm.form.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "firstName", $$v)
                            },
                            expression: "form.firstName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "pl-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "companies-contact-form.form.surnames"
                            )
                          },
                          model: {
                            value: _vm.form.lastName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lastName", $$v)
                            },
                            expression: "form.lastName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    placeholder: _vm.$t("companies-contact-form.form.email")
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email"
                  }
                }),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    placeholder: _vm.$t("companies-contact-form.form.country")
                  },
                  model: {
                    value: _vm.form.country,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "country", $$v)
                    },
                    expression: "form.country"
                  }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "companies-contact-form.form.disclaimers.personal",
                          { platform: _vm.platform }
                        )
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    model: {
                      value: _vm.formLegalConsentOptions.privacyPolicy,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formLegalConsentOptions,
                          "privacyPolicy",
                          $$v
                        )
                      },
                      expression: "formLegalConsentOptions.privacyPolicy"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "companies-contact-form.form.disclaimers.privacy"
                          )
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    attrs: { outline: "", black: "" },
                    on: { click: _vm.sendContactForm }
                  },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fe4aaa4", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/92.9f622ef508965541d922.js